<template>
  <section class="section" :id="`uuid-${$attrs.uuid}`">
    <div class="section__container">

      <component :is="headingTag" :class="headingClass" v-if="title">{{title}}</component>

      <div class="disclaimer" v-html="text"/>

    </div>
  </section>
</template>
<script>
  export default {
    name: "Disclaimer",
    props: {
      title: {
        type: String,
        required: false,
        default: ""
      },
      text: {
        type: String,
        required: false,
        default: ""
      }
    },
    computed: {
      headingClass() {
        return this.headingStyle === "large"
          ? "editorial__title text--heading-l text--center"
          : "editorial__title text--heading-m text--center";
      },
      headingTag() {
        return this.headingStyle === "large" ? "h2" : "h3"; //simplified heading hierarchy for accessibility purpose
      },
    }
  }
</script>